import {register} from '../vendor/theme-scripts/theme-sections';
import popupVideoSection from '../features/popup-video';
import parallaxImage from '../features/image-parallax';
import scrollButton from '../features/scroll-button';

register('video', [parallaxImage, scrollButton, popupVideoSection]);
